import style from './app.module.scss'
import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import NotFound from './components/NotFound404/notFound'
import { AuthView } from './Views/Auth/AuthView'
import { useAppSelector } from './starter/hooks/redux'

import Root from './Views/Root/Root'
import { useGetUserQuery } from './starter/api/userApi'

function App() {
  const { isLoggedIn } = useAppSelector((state) => state.auth)
  const { isLoading: isLoadingUser } = useGetUserQuery()

  return (
    <>
      {isLoadingUser && <div>CHECKING!!!!</div>}
      {!isLoadingUser && (
        <div className={style.page}>
          <Routes>
            <Route path='/*' element={isLoggedIn ? <Root /> : <Navigate to='/signin' replace />} />
            <Route path='/signup' element={isLoggedIn ? <Navigate to='/' replace /> : <AuthView type={'signUp'} />} />
            <Route path='/signin' element={isLoggedIn ? <Navigate to='/' replace /> : <AuthView type={'signIn'} />} />
            <Route path='*' element={<NotFound />} />
          </Routes>
        </div>
      )}
    </>
  )
}
export default App
